import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptEvents } from "../adapters/adaptEvents";

const fetchEvents = async () => {
	const response = await cmsClient.get<IEvent[]>("/homepage/admin/events/");

	return response.data;
};

const useEvents = () => {
	const query = useQuery(["events"], fetchEvents, {
		select: adaptEvents
	});

	return query;
};

export default useEvents;
